<template>
  <div style="display: inline-block; padding: 0; margin: 0">
    <v-btn
        class="ma-0"
        @click="requestRegistration"
        :loading="loading"
        :color="color"
        :small="small"
        :outlined="outlined">
      <v-icon size="18" class="mr-1">{{icon}}</v-icon>
      {{label}}
    </v-btn>
    <kimsa-confirm
      ref="confirmDialog"
      :persistent="true"
      title="Agregar nuevo medio de Pago"
      content="¿Confirmas que deseas agregar un nuevo medio de pago?"
      :loading="loading"
      />
  </div>
</template>

<script>
import KimsaConfirm from "@/components/common/KimsaConfirm";
import {ApiUtils} from "@/utils/ApiUtils";
import {mapState} from 'vuex';

export default {
  name: "CardRegistrationButton",
  components: {KimsaConfirm},
  props:{
    planId:{
      type: Number,
      required: true
    },
    showConfirmDialog: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: 'primary'
    },
    outlined: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: 'Agregar medio de pago'
    },
    icon: {
      type: String,
      default: 'add'
    }
  },
  data(){
    return {
      loading: false
    }
  },
  computed:{
    ...mapState(['currentProvider'])
  },
  methods: {
    requestRegistration(){
      const vm = this
      if(vm.showConfirmDialog){
        return vm.$refs.confirmDialog.show()
      }
      return this.confirmRegistrationRequest()
    },
    async confirmRegistrationRequest(){
      const vm = this
      if(!vm.currentProvider || vm.loading) return
      vm.loading = true
      const response = await ApiUtils.makeGet(
          `providers/${vm.currentProvider.id}/subscription/card-registration/${vm.planId}?cardOnly=1`
      )
      if(!response.ok){
        const json = await response.json()
        vm.toast(json.message || 'Ocurrió un error cambiando el medio de pago', 'error')
        return vm.loading = false
      }

      const json = await response.json()
      document.location.href = json.result.url
      vm.loading = false

    }
  }
}
</script>

<style scoped>

</style>
